import React from 'react';
import { Outlet } from 'react-router-dom';

function Outerlayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
export default Outerlayout;
